export const AI_REASONING_HOVER_SHOW = 'AI_REASONING:HOVER:SHOW';
export const AI_REASONING_HOVER_HIDE = 'AI_REASONING:HOVER:HIDE';
export const AI_REASONING_VERIFY_SUCCESS = 'AI_REASONING_VERIFY:SUCCESS';

/** 组件 $emit 事件名，供外部 @verify-success 监听 */
export const AI_REASONING_VERIFY_SUCCESS_EMIT = 'verify-success';

/** Vue provide/inject key：ReasoningService 实例 */
export const REASONING_SERVICE_INJECT_KEY = Symbol('ReasoningService');

export interface AiReasoningHoverShowPayload {
    referenceEl: HTMLElement;
    patentId: string;
    fieldId: string;
    folderId: string;
    isPersonal: boolean;
}

export interface AiReasoningVerifySuccessPayload {
    patentId: string;
    fieldId: string;
}
